import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Filter } from '@bibliocommons/deprecated-base-icons';
import { bindAll } from '@bibliocommons/utils-react';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { StickyToggleButton } from 'app/components/shared/DrawerLayout';

import './FacetDrawerToggle.scss';

class FacetDrawerToggle extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderFilterCount() {
    if (this.props.activeFilterCount > 0) {
      return (
        <FormattedNumber value={this.props.activeFilterCount}>
          {number => <span>&nbsp;({number})</span>}
        </FormattedNumber>
      );
    }
    return null;
  }

  renderCompact() {
    return (
      <span>
        <Filter className="small" />
        <ScreenReaderMessage>
          <FormattedMessage id="Facets.filterResults" />
        </ScreenReaderMessage>
        {this.renderFilterCount()}
      </span>
    );
  }

  renderFull() {
    return (
      <span className="full-content">
        <Filter className="small" />
        <FormattedMessage id="Facets.filterResults" />
        {this.renderFilterCount()}
      </span>
    );
  }

  render() {
    return (
      <StickyToggleButton
        className="cp-facet-drawer-toggle"
        drawerActions={this.props.drawerActions}
        renderCompact={this.renderCompact}
        renderFull={this.renderFull}
      />
    );
  }
}

FacetDrawerToggle.propTypes = {
  activeFilterCount: PropTypes.number,
  drawerActions: PropTypes.objectOf(PropTypes.func)
};

export default FacetDrawerToggle;
